/*
 * ez-featured-price.js — keep the price in a sale page's buy box in step with the package picked.
 *
 * Eddie, 22 Sep 2026 ("Fix and change all of your recommendations"): on every sale page, choosing the package with
 * monitors left the laptop-only price on screen, while the cart correctly switched to the package. Cause, in
 * assets/global.js: VariantSelects.renderProductInfo() asks the Section Rendering API for section_id = the BLOCK id
 * (section-custom-featured-product passes data-section="{{ block.id }}"), which is not a section, so nothing comes
 * back and the price box is never refreshed.
 *
 * This leaves the theme's code alone. After any change on a variant picker, it finds the chosen variant in the JSON
 * the section already embeds and writes that variant's price into the matching price box (#price-<data-section>).
 * The variant data is the same data the cart uses, so the figure shown is the figure charged.
 * Loaded only by sections/section-custom-featured-product.liquid.
 */
(function () {
  if (window.__ezFeaturedPrice) return;
  window.__ezFeaturedPrice = true;

  function money(cents, sample) {
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var s = (cents / 100).toLocaleString('en-US', { style: 'currency', currency: code });
    return /[A-Z]{3}\s*$/.test(sample || '') ? s + ' ' + code : s;
  }

  function update(picker) {
    var box = picker.dataset.section && document.getElementById('price-' + picker.dataset.section);
    var json = picker.querySelector('script[type="application/json"]');
    if (!box || !json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    var chosen = Array.prototype.map.call(picker.querySelectorAll('select'), function (s) { return s.value; });
    if (!chosen.length) chosen = Array.prototype.map.call(picker.querySelectorAll('input[type="radio"]:checked'), function (i) { return i.value; });
    var v = variants.filter(function (x) {
      return x.options.every(function (o, i) { return chosen[i] === o; });
    })[0];
    if (!v) return;
    var shown = box.querySelector('.price__regular .price-item--regular');
    var sample = shown ? shown.textContent.trim() : '';
    var text = money(v.price, sample);
    Array.prototype.forEach.call(box.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale'), function (el) { el.textContent = text; });
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    var old = box.querySelector('.price__sale-old .price-item--regular');
    if (old) old.textContent = onSale ? money(v.compare_at_price, sample) : '';
    var wrap = box.querySelector('.price');
    if (wrap) wrap.classList.toggle('price--on-sale', !!onSale);
  }

  document.addEventListener('change', function (e) {
    var picker = e.target && e.target.closest && e.target.closest('variant-selects, variant-radios');
    if (!picker) return;
    // after the theme's own handler has chosen the variant for the cart
    setTimeout(function () { update(picker); }, 0);
  });
})();
